import { Button, HStack, Input, Text, VStack, useToast, Box, useColorModeValue, Flex, Icon, Heading, IconButton } from '@chakra-ui/react';
import React, { useContext, useRef } from 'react'
import { AppContext } from '../../../context/AppContext';
import { UseCouponCode } from '../../../utils/api';
import { BsGift } from "react-icons/bs";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';

const PromoCode = () => {
    const { Token, setBalance } = useContext(AppContext);
    const toast = useToast();
    const inputRef = useRef();
    const navigate = useNavigate();

    // Premium UI Colors
    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");
    const textColor = useColorModeValue("gray.800", "white");
    const subTextColor = useColorModeValue("gray.500", "gray.400");
    const inputBg = useColorModeValue("gray.50", "gray.700");

    const handlePromoCode = () => {
        if (inputRef.current.value == "") {
            toast({
                status: "warning",
                title: "Please Enter CouponCode",
                isClosable: true,
                duration: 1000,
            });
            return;
        }
        UseCouponCode(Token, { couponCode: inputRef.current.value.trim() })
            .then((res) => {
                if (res.data.status == 'expired') {
                    toast({
                        status: "info",
                        description: `${res.data.message}`,
                        isClosable: true,
                        duration: 3000,
                    });
                    return;
                }
                setBalance(res.data.balance);
                toast({
                    title: "Congratulations 🎊",
                    status: "success",
                    description: `${res.data.message}`,
                    isClosable: true,
                    duration: 4000,
                });
                inputRef.current.value = "";
            })
            .catch((err) => {
                toast({
                    status: "error",
                    title: err.response?.data.message,
                    isClosable: true,
                });
                console.log(err, "saying error");
            });
    };

    return (
        <VStack w="100%" spacing={8} align="center" py={4}>
            <Box
                bg={cardBg}
                border="1px solid"
                borderColor={borderColor}
                rounded="2xl"
                shadow="lg"
                p={{ base: 6, md: 8 }}
                w={{ base: "100%", md: "600px" }}
                maxW="100%"
            >
                <VStack spacing={6}>
                    <VStack spacing={2}>
                        <Flex
                            align="center"
                            justify="center"
                            bg="purple.50"
                            p={3}
                            rounded="full"
                            color="purple.500"
                            mb={2}
                        >
                            <Icon as={BsGift} boxSize={6} />
                        </Flex>
                        <Heading size="md" color={textColor}>Redeem Promo Code</Heading>
                        <Text color={subTextColor} fontSize="sm" textAlign="center">
                            Enter your promo code below to receive bonus credits
                        </Text>
                    </VStack>

                    <Box w="100%">
                        <Text mb={2} fontWeight="600" fontSize="sm" color={textColor}>Promo Code</Text>
                        <HStack>
                            <Input
                                ref={inputRef}
                                placeholder="Enter code here"
                                size="lg"
                                bg={inputBg}
                                border="1px solid"
                                borderColor={borderColor}
                                _focus={{ borderColor: "purple.500", boxShadow: "0 0 0 1px var(--chakra-colors-purple-500)" }}
                            />
                            <Button
                                size="lg"
                                px={8}
                                onClick={handlePromoCode}
                                colorScheme="purple"
                                _hover={{
                                    transform: "translateY(-2px)",
                                    shadow: "md"
                                }}
                                transition="all 0.2s"
                            >
                                Redeem
                            </Button>
                        </HStack>
                    </Box>
                </VStack>
            </Box>
        </VStack>
    )
}

export default PromoCode;
